// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC
import moment from 'moment'
import ApiRequests from '@/api/ApiRequests'
import Vue from 'vue'

const EMPTY_KEYWORD = 'blank'

const username = []

const state = {
  categories: [],
  images: [],
  numImages: 0,
  // This object must contain all later used properties to avoid reactivity issues
  query: {
    categories: [],
    categoriesEmpty: false,
    dateEnd: null,
    dateStart: null,
    limit: 30,
    or: false,
    tags: [],
    tagsEmpty: false,
    uploader: '',
    uploaderEmpty: false,
    search: '',
    searchEmpty: false,
    searchPartialText: false
  },
  loading: false
}

const getters = {
  getCategories: state => state.categories,
  getImages: state => state.images,
  getLoading: state => state.loading,
  getNumImages: state => state.numImages,
  getQuery: state => state.query,
  getQueryOutput: function (state) {
    var query = {}
    query.categories = ''
    query.tags = ''
    query.uploader = ''
    query.search = ''
    query.limit = state.query.limit

    if (state.query.categoriesEmpty) {
      query.categories = EMPTY_KEYWORD
    } else {
      if (state.query.categories) {
        query.categories = state.query.categories.map(cat => cat.id).join(',')
      }
      if (query.categories === '') {
        delete query.categories
      }
    }

    if (state.query.tagsEmpty) {
      query.tags = EMPTY_KEYWORD
    } else {
      if (state.query.tags) {
        query.tags = state.query.tags.join(',')
      }
      if (query.tags === '') {
        delete query.tags
      }
    }

    if (state.query.uploaderEmpty) {
      query.uploader = EMPTY_KEYWORD
    } else {
      if (state.query.uploader) {
        query.uploader = state.query.uploader
      }
      if (query.uploader === '') {
        delete query.uploader
      }
    }

    if (state.query.searchEmpty) {
      query.search = EMPTY_KEYWORD
    } else {
      if (state.query.search) {
        query.search = state.query.search
      }
      if (query.search === '') {
        delete query.search
      }
    }

    if (state.query.dateEnd) {
      query.before = moment(state.query.dateEnd).format()
    }

    if (state.query.dateStart) {
      query.after = moment(state.query.dateStart).format()
    }

    if (state.query.or && ((typeof query.categories !== 'undefined') || (typeof query.tags !== 'undefined') || (typeof query.uploader !== 'undefined') || (typeof query.search !== 'undefined'))) {
      query.or = state.query.or
    }

    if (state.query.searchPartialText) {
      query.partialsearch = true
    }

    return query
  },

  getTags: function (state) {
    var results = []
    for (var i = 0; i < state.images.length; i++) {
      results = results.concat(state.images[i].tags)
    }
    return results.filter((v, i, a) => a.indexOf(v) === i)
  },

  getUploader: function (state) {
    var results = []
    for (var i = 0; i < state.images.length; i++) {
      if (state.images[i].uploader === '') {
        // console.log('skipping User')
      } else {
        results = results.concat(state.images[i].uploader)
      }
    }
    results = results.filter((v, i, a) => a.indexOf(v) === i)
    if (username.length <= 0) {
      for (const i of results) {
        ApiRequests.getUsername(i).then(response => {
          username.push(response.data)
        }).catch(err => {
          console.log(err + ': This username does not exist')
        })
      }
    }
    return username
  },

  isQuery: function (state) {
    return state.query.categories.length > 0 ||
    state.query.categoriesEmpty === true ||
    state.query.dateEnd !== null ||
    state.query.dateStart !== null ||
    state.query.tags.length > 0 ||
    state.query.tagsEmpty === true ||
    state.query.uploader.length > 0 ||
    state.query.uploaderEmpty === true ||
    state.query.search.length > 0 ||
    state.query.searchEmpty === true
  }
}

const mutations = {
  setCategories (state, categories) {
    state.categories = categories
  },

  setImages (state, images) {
    state.images = images
  },

  toggleImageSelected (state, index) {
    if (index < state.images.length && index >= 0) {
      if (state.images[index].selected) {
        Vue.set(state.images[index], 'selected', false)
      } else {
        Vue.set(state.images[index], 'selected', true)
      }
    }
  },

  setLoading (state, loading) {
    state.loading = loading
  },

  setNumImages (state, num) {
    state.numImages = num
  },

  queryLimitInc (state) {
    state.query.limit = state.query.limit + 30
  },

  // This function must contain all later used properties to avoid reactivity issues
  searchClear (state) {
    state.query = {
      categories: [],
      categoriesEmpty: false,
      dateEnd: null,
      dateStart: null,
      limit: 30,
      or: false,
      tags: [],
      tagsEmpty: false,
      uploader: '',
      uploaderEmpty: false,
      search: '',
      searchEmpty: false
    }
  },

  searchClearCateogry (state, index) {
    state.query.categories.splice(index, 1)
  },

  searchClearTag (state, index) {
    state.query.tags.splice(index, 1)
  },

  searchClearUploader (state) {
    state.query.uploader = ''
  },

  searchClearPartial (state) {
    state.query.search = ''
  },

  searchCategory (state, value) {
    if (state.query.categories.findIndex(i => i.id === value.id) < 0) {
      state.query.categories.push(value)
    }
  },

  searchPartial (state, value) {
    console.log(state.query.search)
    state.query.search = value
  },

  searchPartialText (state, value) {
    console.log(state.query.searchPartialText)
    state.query.searchPartialText = value
  },

  searchCategoryEmptyToggle (state) {
    if (state.query.categoriesEmpty) {
      state.query.categoriesEmpty = false
    } else {
      state.query.categories = []
      state.query.categoriesEmpty = true
    }
  },

  searchDateEnd (state, value) {
    state.query.dateEnd = value
  },

  searchDateStart (state, value) {
    state.query.dateStart = value
  },

  searchOr (state, value) {
    state.query.or = value
  },

  // Used to set the query state up from the route parameters
  searchSetQuery (state, inputQuery) {
    if (inputQuery.after) {
      state.query.dateStart = moment(inputQuery.after)
    }

    if (inputQuery.before) {
      state.query.dateEnd = moment(inputQuery.before)
    }

    if (inputQuery.categories) {
      if (inputQuery.categories === EMPTY_KEYWORD) {
        state.query.categories = []
        state.query.categoriesEmpty = true
      } else {
        state.query.categories = inputQuery.categories.split(',').map(cat => ({'id': cat}))
      }
    }

    if (inputQuery.or) {
      state.query.or = inputQuery.or
    }

    if (inputQuery.tags) {
      if (inputQuery.tags === EMPTY_KEYWORD) {
        state.query.tags = []
        state.query.tagsEmpty = true
      } else {
        state.query.tags = inputQuery.tags.split(',')
      }
    }

    if (inputQuery.search) {
      if (inputQuery.search === EMPTY_KEYWORD) {
        state.query.search = []
        state.query.searchEmpty = true
      } else {
        state.query.search = inputQuery.search
      }
    }

    if (inputQuery.uploader) {
      if (inputQuery.uploader === EMPTY_KEYWORD) {
        state.query.uploader = []
        state.query.uploaderEmpty = true
      } else {
        state.query.uploader = inputQuery.uploader
      }
    }
  },

  searchTag (state, value) {
    if (state.query.tags.indexOf(value) < 0 && value !== '') {
      state.query.tags.push(value)
    }
  },

  searchUploader (state, value) {
    state.query.uploader = value
  },

  searchTagEmptyToggle (state) {
    if (state.query.tagsEmpty) {
      state.query.tagsEmpty = false
    } else {
      state.query.tags = []
      state.query.tagsEmpty = true
    }
  }
}

const actions = {
  fetchCategories (context) {
    ApiRequests.getImageCategories().then(response => {
      context.commit('setCategories', response.data)
    }).catch((e) => {
      console.error('error loading image categories: %o', e)
    })
  },

  fetchImages (context) {
    context.commit('setLoading', true)
    ApiRequests.getImages(context.getters.getQueryOutput).then(r => {
      context.commit('setImages', r.data)
      context.commit('setLoading', false)
      context.commit('setNumImages', parseInt(r.headers['x-total-count']))
    }).catch((e) => {
      console.error('error loading images: %o', e)
    })
  },

  incrementLimit (context) {
    if (context.state.images.length >= context.state.query.limit) {
      context.commit('queryLimitInc')
      context.dispatch('fetchImages')
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/images.js